import React, { FC } from 'react';
import { createPictureFactory } from '@funtech-int/yango-shared';
import { SportTeam } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getCompetitionLabel } from '../../utils/getCompetitionLabel';

import styles from './_SportTeamsEventMeta.module.css';

interface SportTeamsEventMetaProps {
    sportName?: string;
    competitionName?: string;
    firstTeam: SportTeam;
    secondTeam: SportTeam;
}

const teamLogoPictureFactory = createPictureFactory({
    fallback: {
        srcSet: {
            '1x': '66x66',
            '2x': '100x100',
        },
        src: '100x100',
    },
});

export const SportTeamsEventMeta: FC<SportTeamsEventMetaProps> = ({
    sportName,
    competitionName,
    firstTeam,
    secondTeam,
}) => {
    const competitionLabel = getCompetitionLabel(sportName, competitionName);

    const firstTeamLogo = teamLogoPictureFactory({ fallbackUrl: firstTeam.logo?.avatarsUrl }).img
        .src;
    const secondTeamLogo = teamLogoPictureFactory({ fallbackUrl: secondTeam.logo?.avatarsUrl }).img
        .src;

    return (
        <div className={styles.sportBaseEventMeta}>
            {competitionLabel && <div className={styles.competitionLabel}>{competitionLabel}</div>}
            <div className={styles.teams}>
                <div className={styles.team}>
                    {firstTeam.logo?.avatarsUrl && (
                        <img className={styles.teamLogo} src={firstTeamLogo} alt={firstTeam.name} />
                    )}
                    <div className={styles.teamName}>{firstTeam.name}</div>
                </div>
                <div className={styles.team}>
                    {secondTeam.logo?.avatarsUrl && (
                        <img
                            className={styles.teamLogo}
                            src={secondTeamLogo}
                            alt={secondTeam.name}
                        />
                    )}
                    <div className={styles.teamName}>{secondTeam.name}</div>
                </div>
            </div>
        </div>
    );
};
